import { transition } from '@helpers/animation';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
import HeadingStyles from './Heading.styles';
/**
 * 20px / 28px
 */
export const LargeStyles = css `
  ${fonts.sofiaPro.regular};
  font-size: 20px;
  letter-spacing: normal;
  line-height: 30px;
  margin-bottom: 16px;

  @media ${from(Device.Mobile)} {
    font-size: 20px;
    line-height: 30px;
  }

  @media ${from(Device.Tablet)} {
    font-size: 22px;
    line-height: 32px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 26px;
    line-height: 36px;
  }
`;
/**
 * 18px / 28px
 */
export const RegularStyles = css `
  ${fonts.sofiaPro.regular};
  font-size: 18px;
  letter-spacing: normal;
  line-height: 28px;
  margin-bottom: 16px;
`;
/**
 * 16px / 26px
 */
const SmallStyles = css `
  ${fonts.sofiaPro.regular};
  font-size: 16px;
  letter-spacing: normal;
  line-height: 26px;
  margin-bottom: 16px;

  @media ${from(Device.Desktop)} {
    font-size: 18px;
    line-height: 28px;
  }
`;
const linkStyles = css `
  ${transition('text-decoration-color', 0.2)};

  ${fonts.sofiaPro.bold};

  color: ${brand.primary.blue.base};
  text-decoration: underline;
  text-decoration-color: currentColor;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;

  &:hover,
  &:focus {
    text-decoration-color: transparent;
  }
`;
const tableStyles = css `
  ${SmallStyles};

  margin: 0 0 16px;
  table-layout: fixed;
  text-align: left;
  width: 100%;

  td,
  th {
    padding: 16px 10px;

    @media ${from(Device.Tablet)} {
      padding: 16px;
    }
  }

  thead {
    ${fonts.sofiaPro.semiBold};

    tr {
      border-bottom: 1px solid ${brand.primary.blue.base};
    }
  }

  tbody {
    tr {
      &:nth-child(even) {
        background-color: ${brand.primary.grey.base};
      }
    }
  }
`;
const contentStyles = css `
  h1 {
    ${HeadingStyles.H1Styles};
  }

  h2 {
    ${HeadingStyles.H2Styles};
  }

  h3 {
    ${HeadingStyles.H3Styles};
  }

  h4 {
    ${HeadingStyles.H4Styles};
  }

  h5 {
    ${HeadingStyles.H5Styles};
  }

  p {
    ${SmallStyles};
  }

  strong {
    ${fonts.sofiaPro.bold};
  }

  figure {
    margin: 30px 0;
  }

  figcaption {
    margin-top: 5px;
    ${fonts.sofiaPro.light};
    text-transform: uppercase;
  }

  ol,
  ul {
    display: block;
    ${SmallStyles};
    padding: 0 0 0 40px;
  }

  ol {
    list-style: decimal;

    li {
      display: list-item;
      margin-bottom: 1em;
    }
  }

  ul {
    list-style: disc;

    li {
      display: list-item;
      margin-bottom: 1em;
    }
  }

  a {
    ${linkStyles};
  }

  table {
    ${tableStyles};
  }

  hr {
    margin: 16px 0;
  }

  sup {
    position: relative;
    top: -0.5em;
    font-size: 80%;
  }

  sub {
    position: relative;
    top: 0.5em;
    font-size: 80%;
  }

  *:last-child {
    margin-bottom: 0;
  }
`;
const Paragraph = styled.p `
  ${contentStyles}

  ${({ size }) => {
    switch (size) {
        case 'large':
            return LargeStyles;
        case 'regular':
            return RegularStyles;
        case 'small':
            return SmallStyles;
        default:
            break;
    }
}}
`;
export default {
    contentStyles,
    linkStyles,
    tableStyles,
    Paragraph,
    SmallStyles,
    RegularStyles,
    LargeStyles,
};
